import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=577608cc"
import script from "./Teaser.js?vue&type=script&lang=js&external"
export * from "./Teaser.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports